import { createContext, useContext } from 'react';
import { useStore } from 'zustand';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const GameStoreContext = createContext(null);
export const useGameStore = (selector)=>{
    const gameStore = useContext(GameStoreContext);
    if (gameStore === null) throw new Error('GameStoreContext.Provider is missing in the component tree');
    return useStore(gameStore, selector);
};
